import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { createRedirectToken } from "../services/api";

const LoginSuccess: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"loading" | "redirecting" | "error">(
    "loading"
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (token) {
      localStorage.setItem("token", token);

      // Check if we need to redirect to tenant subdomain
      createRedirectToken()
        .then((redirectData) => {
          if (redirectData.alreadyOnCorrectDomain) {
            // User is already on correct domain - go to dashboard
            navigate("/");
          } else {
            // Redirect to correct tenant domain
            setStatus("redirecting");
            window.location.href = `${redirectData.redirectUrl}/login-redirect?rt=${redirectData.redirectToken}`;
          }
        })
        .catch((err) => {
          console.error("Redirect failed:", err);
          setStatus("error");
          // Fallback: just navigate to main dashboard
          setTimeout(() => navigate("/"), 2000);
        });
    } else {
      navigate("/login");
    }
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
      <div className="text-center">
        {status === "loading" && (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
            <h2 className="text-2xl font-semibold text-neutral-900">
              Logowanie...
            </h2>
            <p className="text-neutral-600 mt-2">Proszę czekać chwilę.</p>
          </>
        )}

        {status === "redirecting" && (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
            <h2 className="text-2xl font-semibold text-neutral-900">
              Przekierowanie do Twojej przestrzeni roboczej...
            </h2>
            <p className="text-neutral-600 mt-2">
              Przekierowanie do panelu Twojej organizacji.
            </p>
          </>
        )}

        {status === "error" && (
          <>
            <h2 className="text-2xl font-semibold text-red-600">
              Przekierowanie nie powiodło się
            </h2>
            <p className="text-neutral-600 mt-2">
              Przekierowanie do głównego panelu...
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginSuccess;
